import React, { forwardRef, Ref } from "react";
import { FieldValues, UseControllerProps } from "react-hook-form";

import styled from 'styled-components'

// Controlled components are form elements (like input , textarea , or select ) that are managed by React state
export const Wrapper = styled.article`
  margin-bottom: 1.5rem;
  
  .form:hover {
    box-shadow: var(--shadow-4);
  }
  .form-label {
    display: block;
    font-weight: 800;
    font-size: var(--smallText);
    margin-bottom: 0.5rem;
    text-transform: uppercase;
    letter-spacing: var(--letterSpacing);
  }
  .form-input,
  .form-textarea,
  .form-select {
    padding: 0.375rem 0.75rem;
    border-radius: var(--fine-border-radius);
    background: var(--white);
    border: 1px solid var(--grey-200);
  }
  .form-input,
  .form-select,
  .btn-block {
    height: 35px;
  }
  .form-row {
    display: grid;
    grid-template-columns: 1fr
    
  }
`
interface GenericSelectFieldProps<T extends FieldValues>
    extends UseControllerProps<T> {
      list: Array<{itemValue: string}>,
      label: string,
      className: string,
      value: string | undefined,
      error: string | undefined,
      onBlur: any,
      onChange: any
}
export const SelectRow = forwardRef(<T extends FieldValues>({ 
  control,
  list, 
  label, 
  className,
  value,
  error,
  onBlur, 
  onChange, 
}: {
  list: Array<{itemValue: string}>,
  label: string,
  className: string,
  value: string | undefined,
  error: string | undefined,
  onBlur: any,
  onChange: any
} & GenericSelectFieldProps<T>, ref:Ref<HTMLInputElement>) => {
  
  
  return (
    <Wrapper>
    <div className="form-row">
      <label htmlFor={label} className='form-label'>
        {label}
      </label>
      <select
        {...ref}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        className={className}
      >
        <option key='0'>Choose</option>
        {list.map((item, index) => {
          return (
            <option key={index} value={item.itemValue}>
              {item.itemValue}
            </option>
          )
        })}
      </select>
      <small className="text-danger">
        {error}
      </small>
    </div>
  </Wrapper>
 );
})
